import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { PostClinicPartnerInvitationArgs, PostClinicPartnerInvitationResponse } from "../schemas/invitations";

export const usePostClinicPartnerInvitation = () => {
  const client = useApiClient();

  return useMutation<PostClinicPartnerInvitationResponse, Error, PostClinicPartnerInvitationArgs>({
    mutationFn: args => client.postClinicPartnerInvitation(args),
  });
};
